if (!customElements.get('roomix-dimensions')) {
  customElements.define('roomix-dimensions', class roomixDimensions extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('.fields input');
      this.selects = this.querySelectorAll('.fields select');
      this.lengthInput = this.querySelector('#dynamic-length');
      this.depthInput = this.querySelector('#dynamic-depth');
      this.pricePerUnit = this.dataset.pricePerUnit;
      this.minPrice = Number(this.dataset.minPrice);
      this.maxPrice = Number(this.dataset.maxPrice);
      const dynamicHeightInput = this.querySelector('#dynamic-height');



      if (dynamicHeightInput) {
        this.heightInput = dynamicHeightInput;
      }

      this.productId = meta['product']['id'];

      this.form = document.querySelector('product-form form');
      //this.requestIdElement = document.getElementById('request_id');
      this.createtRequestIdElement = document.getElementById('create_request_id');
      this.variantIdElement = document.getElementById('variant_id');
      this.requestedPrice = document.getElementById('requested_price');

      // this.validationElements = document.querySelectorAll('.validation');

      this.submitButton = document.querySelector('product-form [type="submit"]')

    }

    connectedCallback() {


      if (this.inputs.length > 0) {
        this.inputs.forEach((input) => {
          input.addEventListener('change', this.onChangeInput);
        });
      }

      if (this.selects.length > 0) {
        this.selects.forEach((select) => {
          select.addEventListener('change', this.onChangeInput);
        });
      }

      const quantityInput = this.querySelector('quantity-input input');
      if (quantityInput) {
        quantityInput.addEventListener('change', this.quantityChanged);
      }

      this.initialize();
    }

    initialize = () => {
      if (document.querySelectorAll('input[name="properties[Dimensions]"]').length === 0) {
        this.createHiddenFormInputProperty('properties[Dimensions]');
      }
      this.onChangeInput();
    }

    getVariantInfoFromApi = async (product_id, length, depth, heightInput, createProduct) => {

      let url = 'https://roomixdiy.tible.tech/product.json';
      let data = new FormData();
       data.set('product_id', product_id);
       data.set('length', length);
       data.set('depth', depth);
       data.set('create_product', createProduct);

      if (heightInput != null) {
        data.set('height', this.heightInput.value);
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          body: data
        });

        const responseData = await response.json();
        return { status_code: response.status, data: responseData };
      } catch (error) {
        console.error(error);
        return { status_code: 500, data: null };
      }
    }

    updateVariantId = (value, createProduct) => {
      this.variantIdElement.innerHTML = value;
      this.variantIdElement.setAttribute('data-variant-id', value);
      this.dataset.variantId = value;

      // update price check for new form
      document.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = value;
      });

      if (createProduct) {
        this.submitButton.removeAttribute('aria-disabled')
        this.submitButton.classList.remove('loading')
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
      }

    }

    minMaxValidation = (event) => {
      let inputElement = event.target

      if (inputElement.type === "number" && inputElement.max && inputElement.min ){
        let value = parseFloat(Number(inputElement.value).toFixed(1));
        inputElement.value = value // for 000 like input cleanup to 0
        let max = parseFloat(inputElement.max)
        let min = parseFloat(inputElement.min)
        if ( value > max ) inputElement.value = inputElement.max
        if ( value < min ) inputElement.value = inputElement.min
      }
    }

    calculatePrice = () => {
      let priceBuilder = this.lengthInput.value * this.depthInput.value * this.pricePerUnit;
      if (this.heightInput) {
        priceBuilder = priceBuilder * this.heightInput.value;
      }
      let priceTwoDecimals = Math.round((priceBuilder + Number.EPSILON) * 100) / 100;

      if (this.minPrice > 0 || this.maxPrice > 0) {
        if (priceTwoDecimals < this.minPrice) {
          priceTwoDecimals = this.minPrice;
        } else if (priceTwoDecimals > this.maxPrice) {
          priceTwoDecimals = this.maxPrice;
        }
      }

      this.requestedPrice.innerHTML = '£' + priceTwoDecimals;
      this.dataset.price = priceTwoDecimals;
      document.querySelector('price-mirror').updatePrice();
    }

    onChangeInput = (event) => {
      if (event) {
        this.minMaxValidation(event);
      }
      this.updateVariantId('pending', false);
      this.calculatePrice();
      this.checkIfProductExists();
      this.updateProperties('properties[Dimensions]');
    }

    createHiddenFormInputProperty = (value) => {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = value;
      this.form.appendChild(hiddenInput);
      this.updateProperties(hiddenInput.name);
    }

    updateProperties = (value) => {
      let length = this.lengthInput.closest('.field_wrapper').querySelector('label').innerText + ':' + this.lengthInput.value + 'cm'
      let depth = '|' + this.depthInput.closest('.field_wrapper').querySelector('label').innerText + ':' + this.depthInput.value + 'cm';
      let height = this.heightInput ? '|' + this.heightInput.closest('.field_wrapper').querySelector('label').innerText + ':' + this.heightInput.value + 'cm' : '';
      if (document.querySelector('input[name="'+ value +'"][type="hidden"]')) {
        document.querySelector('input[name="'+ value +'"][type="hidden"]').value =  length + depth + height;
      } else {
        if (document.querySelectorAll('input[name="properties[Dimensions]"]').length === 0) {
          this.createHiddenFormInputProperty('properties[Dimensions]');
        }
        document.querySelector('input[name="'+ value +'"][type="hidden"]').value =  length + depth + height;
      }
    }
    quantityChanged = (event) => {
      this.calculatePrice();
      if (document.querySelectorAll('[data-match-quantity]').length > 0) {
        document.querySelectorAll('[data-match-quantity]').forEach((input) => {
          input.value = event.target.value;
          console.log(event.target.value)
          input.closest('.quantity-price').querySelector('[data-total-match-quantity]').textContent = 'Quantity: ' + event.target.value;
          input.closest('optional-items').calculateElementPrice(true);
        });
      }
    }
    checkIfProductExists = async () => {

      try {
        let heightInput_value = this.heightInput ? this.heightInput.value : null;
        const request = await this.getVariantInfoFromApi(this.productId, this.lengthInput.value, this.depthInput.value, heightInput_value, false);

        let variantId = request.data.child_variant_shopify_id;

        // @juanmingo: No he querido "meterle mano" a tu código mucho. Simplemente le comento esto para que siempre "cree" el producto  y así lo "actualice" porque si no el precio no cambia nunca. 
        // if (variantId !== '') {
        //   this.updateVariantId(request.data.child_variant_shopify_id, false);
        // } else {
        //   this.updateVariantId('pending', false);
        // }
        this.updateVariantId('pending', false);

      } catch (error) {
        // Handle errors from the API call
        console.error('Error creating product:', error);
      }
    }

    createProduct = async () => {

      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading');
      this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.variantIdElement.innerHTML === 'pending') {
        try {
          // Call API and create product

          let heightInput_value = this.heightInput ? this.heightInput.value : null;
          const request = await this.getVariantInfoFromApi( this.productId, this.lengthInput.value, this.depthInput.value, heightInput_value, true,);


          this.updateVariantId(request.data.child_variant_shopify_id, true);
          document.querySelector('product-form').onSubmitHandler(new Event('submit'));
        } catch (error) {
          // Handle errors from the API call
          console.error('Error creating product:', error);
        }
      } else {
        document.querySelector('product-form').onSubmitHandler(new Event('submit'));
      }
    };
  });
}